import { useState } from 'react';
import { Link } from 'react-router';
import { authService } from '../../lib/api-service';
import logoImage from '@/imports/AlbaIuliaCTRo_logo.svg';
import { Mail } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await authService.requestPasswordReset(email);
    } catch {
      // Always show success to prevent email enumeration
    }
    setSent(true);
    setSubmitting(false);
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f8f8fa] px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <img src={logoImage} alt="CTRo 2026" className="mx-auto mb-6 h-12" />
          <h1
            className="text-2xl font-bold text-[var(--vivid-purple)]"
            style={{ fontFamily: 'var(--font-primary)' }}
          >
            Resetare parolă
          </h1>
        </div>

        <div className="rounded-2xl border bg-white p-6 shadow-sm">
          {sent ? (
            <div className="text-center">
              <Mail className="mx-auto mb-4 h-10 w-10 text-[var(--vivid-purple)]" />
              <p className="mb-2 text-sm font-semibold" style={{ fontFamily: 'var(--font-primary)' }}>
                Verifică-ți email-ul
              </p>
              <p className="mb-4 text-sm text-muted-foreground" style={{ fontFamily: 'var(--font-secondary)' }}>
                Dacă adresa {email} este asociată unui cont de staff, vei primi un link de resetare.
              </p>
              <Link
                to="/cont"
                className="text-sm font-medium text-[var(--vivid-purple)] hover:underline"
                style={{ fontFamily: 'var(--font-primary)' }}
              >
                Înapoi la autentificare
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <p className="mb-4 text-sm text-muted-foreground" style={{ fontFamily: 'var(--font-secondary)' }}>
                Introdu adresa de email asociată contului tău de staff.
              </p>
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="mb-1.5 block text-sm font-medium"
                  style={{ fontFamily: 'var(--font-primary)' }}
                >
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoFocus
                  className="w-full rounded-lg border px-3 py-2.5 text-sm outline-none transition-colors focus:border-[var(--vivid-purple)] focus:ring-2 focus:ring-[var(--vivid-purple)]/20"
                  style={{ fontFamily: 'var(--font-secondary)' }}
                />
              </div>
              <button
                type="submit"
                disabled={submitting}
                className="w-full rounded-lg bg-[var(--vivid-purple)] py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[var(--vivid-purple)]/90 disabled:opacity-60"
                style={{ fontFamily: 'var(--font-primary)' }}
              >
                {submitting ? 'Se trimite...' : 'Trimite link de resetare'}
              </button>
              <div className="mt-4 text-center">
                <Link
                  to="/cont"
                  className="text-sm text-muted-foreground hover:text-foreground"
                  style={{ fontFamily: 'var(--font-secondary)' }}
                >
                  Înapoi la autentificare
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
